import {JsonApiModelConfig, JsonApiModel, Attribute, HasMany, BelongsTo} from 'angular2-jsonapi';
import {Address} from "./address";
import {Appointment} from "./appointment";
import {ReportCategory} from "./report-category";
import * as moment from "moment";
import {PageMetaData} from "./PageMetaData";

@JsonApiModelConfig({
  type: 'report',
  meta: PageMetaData
})
export class Report extends JsonApiModel {

  @Attribute()
  subject: string;

  @Attribute()
  description: string;

  @Attribute()
  reminder: Date | null;

  @BelongsTo()
  appointment: Appointment;

  @Attribute()
  todo: boolean = false;

  @Attribute()
  important: boolean = false;

  @BelongsTo()
  category: ReportCategory;

  @Attribute()
  created_at: Date;

  @Attribute()
  updated_at: Date;

  @Attribute()
  location: string;

  public get modified(): boolean {
    return (this.created_at != null && moment(this.created_at).isSame(this.updated_at, 'day'));
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/report.ts